import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Coordinates } from '../../shared/types'
import { getDistanceMeters } from '../../shared/utils/distance.utils'
import { AppThunk } from '../../app/store'
import { DISTANCE_THRESHOLD_METERS } from './constants'
import { fetchNearbyPOIsAndMap } from '../poi/poiThunks'

interface UserLocationState {
  coords: Coordinates | null
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error?: string | null
  overridden: boolean
}

const initialState: UserLocationState = {
  coords: null,
  status: 'idle',
  error: null,
  overridden: true,
}

const userLocationSlice = createSlice({
  name: 'userLocation',
  initialState,
  reducers: {
    setCoords(state, action: PayloadAction<Coordinates>) {
      state.coords = action.payload
    },
    setLocationError(state, action: PayloadAction<string>) {
      state.status = 'failed'
      state.error = action.payload
    },
    setLoading(state) {
      state.status = 'loading'
      state.error = null
    },
    setSuccess(state) {
      state.status = 'succeeded'
      state.error = null
    },
    setManualOverride(state, action: PayloadAction<boolean>) {
      state.overridden = action.payload
    },
  },
})

export const { setCoords, setLocationError, setLoading, setSuccess } =
  userLocationSlice.actions

export default userLocationSlice.reducer

export const updateLocationIfMoved =
  (newCoords: Coordinates): AppThunk =>
  async (dispatch, getState) => {
    const prev = getState().userLocation.coords

    const shouldSend =
      !prev ||
      getDistanceMeters(prev.lat, prev.long, newCoords.lat, newCoords.long) >=
        DISTANCE_THRESHOLD_METERS

    if (!shouldSend) return

    dispatch(setLoading())

    try {
      dispatch(setCoords(newCoords))
      dispatch(setSuccess())
      console.log('III')

      dispatch(fetchNearbyPOIsAndMap(newCoords)) // Only trigger POI fetch from here
    } catch (err: any) {
      dispatch(setLocationError(err.response?.data || err.message))
    }
  }
